module.exports = __webpack_public_path__ + "static/media/interior1.78cc62f7.png";